import { DateTime } from 'luxon'
import { memo } from 'react'
import { Card } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { IconWarningCircular, IconWarningTriangle } from '@/common/icons.jsx'
import { localDate } from '@/common/utils.jsx'

/* Displays a warning banner when a contract/employment end date is set */
const EmploymentEndBanner = ({ endDate }) => {
	const { t, i18n } = useTranslation()

	if (!endDate) return null

	const formattedEndDate = DateTime.fromISO(endDate)
		.setLocale(i18n.resolvedLanguage)
		.toLocaleString(DateTime.DATE_SHORT)

	if (endDate > localDate()) {
		return (
			<Card className="mb-3 employmentEndingBanner">
				<Card.Body>
					<IconWarningTriangle /> {t('EmploymentEndingOnBannerText', { endDate: formattedEndDate })}
				</Card.Body>
			</Card>
		)
	}

	return (
		<Card className="mb-3 employmentEndedBanner">
			<Card.Body>
				<IconWarningCircular /> {t('EmploymentEndedBannerText', { endDate: formattedEndDate })}
			</Card.Body>
		</Card>
	)
}

EmploymentEndBanner.displayName = 'EmploymentEndBanner'

export default memo(EmploymentEndBanner)
